import React from 'react';
import { HeaderIcon, NaviIconNotificationNew } from '@banhala/ui-kit';
import { bridge, useNavigator } from '../../utils';

interface NotificationIconProps {
  screen: string;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({
  screen,
}) => {
  const { navigator } = useNavigator();
  const handlePressNotification = () => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_NOTIFICATION_ICON',
      analytics: {
        SCREEN: screen,
      },
    });
    navigator.moveToNotification();
  };
  return (
    <HeaderIcon onPress={handlePressNotification}>
      <NaviIconNotificationNew />
    </HeaderIcon>
  );
};
